import iconsPackage from "@magalu/tom-icons/package.json";

import mixerWebPackage from "../../package.json";

const getVersions = async (
  _ctx: unknown,
  props: { data?: Record<string, unknown> },
  _args: unknown
) => {
  props.data = {
    ...(props.data || {}),
    iconsVersion: iconsPackage.version,
    version: mixerWebPackage.version,
  };
};

export default getVersions;
